export default "__VITE_ASSET__4f41618e__"